import { render, staticRenderFns } from "./WhySection.vue?vue&type=template&id=79deef02&scoped=true&"
import script from "./WhySection.vue?vue&type=script&lang=js&"
export * from "./WhySection.vue?vue&type=script&lang=js&"
import style0 from "./WhySection.vue?vue&type=style&index=0&id=79deef02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79deef02",
  null
  
)

export default component.exports